<template>
  <form @submit.prevent="onSubmit">
    <b-alert v-if="$enums.SESSION.SIGNUP_FAILED.eql(session_status)" show variant="danger">
      <h3 class="size-0 mt-0">
        Error
      </h3>
      <ul class="mb-0">
        <li v-for="(err, index) in session_errors" :key="index">
          {{ err }}
        </li>
      </ul>
    </b-alert>

    <b-form-group
      label="Email Address"
      label-for="email-input"
    >
      <b-form-input id="email-input" v-model="email" type="email" :required="true" placeholder="Enter your email" />
    </b-form-group>

    <b-form-group
      label="Password"
      label-for="password-input"
    >
      <b-form-input id="password-input" v-model="password" type="password" :required="true" placeholder="Enter your password" />
    </b-form-group>

    <b-form-group
      label="Confirm Password"
      label-for="confirm-password-input"
    >
      <b-form-input id="confirm-password-input" v-model="confirmPassword" type="password" :required="true" placeholder="Confirm your password" />
    </b-form-group>

    <div class="form-group mb-0 text-center">
      <button :disabled="$enums.SESSION.LOGGING_IN.eql(session_status)" class="btn btn-primary btn-block" type="submit">
        <template v-if="$enums.SESSION.LOGGING_IN.eql(session_status)">
          <b-spinner small />
          <span class="ml-1">Signing Up...</span>
        </template>
        <template v-else>
          Sign Up
        </template>
      </button>

      <router-link
        :to="{ name: 'Demo' }"
        class="btn btn-outline-primary btn-block"
      >
        View Demo Account
      </router-link>
    </div>
  </form>
</template>

<script>
import {
  mapState,
  mapGetters,
} from 'vuex';

import {
  BFormGroup,
  BFormInput,
  BAlert,
  BSpinner,
} from 'bootstrap-vue';

import SESSION_STATUS from '@/enums/Session';
import types from '@/store/types/authorization';


export default {
  name: 'Signup',
  components: {
    'b-form-group': BFormGroup,
    'b-form-input': BFormInput,
    'b-alert': BAlert,
    'b-spinner': BSpinner,
  },

  data() {
    return {
      email: '', // `${Math.random()}stuart@stuartashworth.com`,
      password: '', // 'password=1',
      confirmPassword: '', // 'password=1',
    };
  },

  computed: {
    ...mapState({
      session_status: state => state.authorization.session_status,
      session_errors: state => state.authorization.session_errors,
    }),

    ...mapGetters([
      'isError',
    ]),
  },

  methods: {
    onSubmit() {
      this.onLoginUser(this.email, this.password, this.confirmPassword);
    },

    /**
		 * Handler for `login` event of the `Login` component.
		 * This will attempt a login and, if successful, move them to the `home` route.
		 * @method
		 * @param  {string}  email    The email address of the user
		 * @param  {string}  password The password of the user
		 * @return {Promise}          [description]
		 */
    async onLoginUser(email, password, confirmPassword) {
      const status = await this.$store.dispatch(types.actions.SIGNUP_USER, {
        email,
        password,
        confirmPassword,
      });

      if (SESSION_STATUS.LOGGED_IN.eql(status)) {
        this.$emit('signedup');
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.app-name {
    color: #343a40;
    font-weight: bold;
    font-size: 2rem;

    span:last-child {
      color: #fb6d9d;
    }
}

h3 {
  font-size: 1.1rem;
}

</style>
